interface BulkStepsHeaderProps {
  current: 1 | 2 | 3;
}

const steps = [
  { id: 1, label: 'Upload' },
  { id: 2, label: 'Review' },
  { id: 3, label: 'Confirm' },
] as const;

export default function BulkStepsHeader({ current }: BulkStepsHeaderProps) {
  return (
    <div className="flex items-center justify-center gap-2 sm:gap-4">
      {steps.map((step, index) => {
        const done = step.id < current;
        const active = step.id === current;
        return (
          <div key={step.id} className="flex items-center gap-2 sm:gap-4">
            <div className="flex items-center gap-2">
              <span
                className={`flex h-8 w-8 items-center justify-center rounded-full text-sm font-label font-semibold transition-colors duration-500 ${
                  done
                    ? 'bg-accent-500 text-background-50'
                    : active
                      ? 'step-current bg-primary-500 text-background-50'
                      : 'bg-background-300 text-foreground-600'
                }`}
              >
                {done ? <i className="ri-check-line animate-pop" /> : step.id}
              </span>
              <span
                className={`text-sm font-label font-medium ${
                  active ? 'text-foreground-950' : 'text-foreground-500'
                }`}
              >
                {step.label}
              </span>
            </div>
            {index < steps.length - 1 ? (
              // The line fills in green once this step is done.
              <span data-done={done} className="step-line h-0.5 w-8 rounded-full bg-background-300 sm:w-16">
                <span className="rounded-full bg-accent-400" />
              </span>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}